module.exports = __webpack_public_path__ + "media/images/logos/twitter-bird-light-bgs-9c6c779ef64bd411bd8cb6439eefff2a.png";